module.exports = __webpack_public_path__ + "media/sent-message.217aeda9.ogg";